import { ServiceBase } from "../ServiceBase";
import { IVerticalGamesListService } from "./vertical-games-list.service.interface";
import { VerticalGamesListComponent } from "../../components/vertical-games-list/vertical-games-list.component";
import React from "react";
import {SwiperGamesListConfiguration} from "../configurations/config-data-sections/arenas.configuration";

const SEO_CATEGORY: string = "Game Drawer";

export class VerticalGamesListService extends ServiceBase implements IVerticalGamesListService {
    public async renderList(gamesList: SwiperGamesListConfiguration): Promise<void> {
        const gamesInfo = await this.services.games.getGamesInfoArray(gamesList.gamesId);
        this.services.drawer.right.push({
            render: () => <VerticalGamesListComponent drawer={this.services.drawer.right}
                                                      gamesInfo={gamesInfo}
                                                      seoCategory={SEO_CATEGORY}
                                                      listTitle={gamesList.title}
                                                      widgetConf={gamesList.jackpotWidget}/>
        });
        this.services.analytics.sendAnalytics(SEO_CATEGORY, gamesList.title, "open");
    }

}